import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { LgvClientService, LgvUserService, NotificationService } from '../../core/core.module';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { finalize, first } from 'rxjs/operators';
import { Modal } from '../modal-form/modal-form-model';
import { ConfirmEmailLoginLinkModalComponent } from '../confirm-login-link-modal/confirm-login-link-modal.component';

@Component({
  selector: 'lgv-client-login-link-modal',
  templateUrl: './client-login-link-modal.component.html',
  styleUrls: ['./client-login-link-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientLoginLinkModalComponent implements OnInit {

  ClientTokenUrl: string = "";
  ClientIDParam: string = "";
  MakeExpired: boolean = false;
  IsLoadingLink$ = new BehaviorSubject<boolean>(true);
  dialogAttr: Modal;

  constructor(
    private lgvClientSvc: LgvClientService,
    private notificationSvc: NotificationService,
    public matDialog: MatDialog,
    public lgvUserService: LgvUserService,
    public dialogRef: MatDialogRef<ClientLoginLinkModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ClientIDParam = this.data.content.clientId;
    this.MakeExpired = this.data.content.makeExpired;
    this.dialogAttr = {
      title: '',
      content: null,
      startButtonText: 'SUBMIT',
      endButtonText: 'RETURN',
      startButtonKey: 'SUBMIT',
      endButtonKey: 'CANCEL',
    }
  }

  onCancel() {
    this.dialogRef.close({ action: false });
  }

  ngOnInit(): void {
    this.lgvClientSvc.generateClientToken(this.ClientIDParam, this.MakeExpired ? -6 : 1)
      .pipe(
        first(),
        finalize(() => this.IsLoadingLink$.next(false))
      )
      .subscribe({
        next: (x) => {
          const curUrlParts = window.location.href.split('#');

          if (curUrlParts.length !== 2) {
            this.notificationSvc.error('Unexpected URL format');
            return;
          }

          this.ClientTokenUrl = `${curUrlParts[0]}#/token/ct/${x.token}`;
        },
        error: (err) => {
          this.notificationSvc.error('Failed to generate client token');
        }
      });
  }

  onCopyLink() {
    navigator.clipboard.writeText(this.ClientTokenUrl).then(() => {
      const confirmationMessage = 'The Client Login Link was copied to the clipboard.';
      this.matDialog.open(ConfirmationDialogComponent, {
        width: '400px',
        data: { Confirmation: confirmationMessage }
      });
    }).catch(() => {
      this.notificationSvc.error('Failed to copy the link.');
    });
  }

  openDialog(data: Modal, component, size) {
    return this.matDialog.open(component, {
      width: size,
      panelClass: 'dialog-container',
      disableClose: true,
      data
    });
  }

  onSendLink() {
    this.dialogAttr.title = 'Send Client Login Link';
    this.dialogAttr.content = { clientId: this.ClientIDParam };
    this.openDialog(this.dialogAttr, ConfirmEmailLoginLinkModalComponent, '350px');
  }
}
